import React, { lazy, Suspense } from "react";

const Editor = lazy(() => import("components/shared/editor.js"));

const Body = ({ renderField, renderFiles, editorValue, onChange, header }) => {
    return (
        <>
            {renderField(header)}
            {renderFiles()}
            <Suspense fallback={<div className="loading" />}>
                <Editor value={editorValue} onChange={(value) => onChange({ name: "text", value })} />
            </Suspense>
        </>
    );
};

export default Body;
